<template>
  <div class="page-wraper">
    <dataForm
      :items="items"
      ref="dataForm"
      class="data-form"
      :onOptionsLoadAfter="onOptionsLoadAfter"
    >
    </dataForm>
    <div class="img-box">
      <div class="attachmentFiles" v-if="data.AttachmentFiles">
        <p>介绍信</p>
        <img :src="data.AttachmentFiles" alt="" />
        <van-button
          type="info"
          size="small"
          style="margin-right: 5px;"
          @click="viewImg(data.AttachmentFiles)"
          >查看</van-button
        >
        <!-- <van-button size="small" @click="downloadImage(data.AttachmentFiles)"
          >下载</van-button
        > -->
      </div>
      <div
        class="introductionImageUrls"
        v-if="data.IntroductionImageUrls && data.IntroductionImageUrls.length"
      >
        <p>附件</p>
        <!-- <div style="display: flex;"> -->
        <div
          v-for="(item, index) in data.IntroductionImageUrls"
          :key="item"
          style="width: 50%;float: left;margin-bottom: 5px;"
        >
          <div>
            <img :src="item" alt="" />
            <van-button
              type="info"
              size="small"
              style="margin-right: 5px;"
              @click="viewImg(item)"
              >查看</van-button
            >
            <!-- <van-button size="small" @click="downloadImage(item)"
              >下载</van-button
            > -->
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div
      class="footer-button"
      v-if="data.AbleToConfirm || data.ConfirmResult == 1"
    >
      <van-button
        class="check"
        :style="{ width: type == 'check' ? '49%' : '18%' }"
        type="info"
        :disabled="!data.AbleToConfirm || loading"
        @click="onCheck(1)"
        size="small"
        >同意</van-button
      >
      <van-button
        class="check"
        :style="{ width: type == 'check' ? '49%' : '18%' }"
        type="danger"
        size="small"
        :disabled="!data.AbleToConfirm || loading"
        @click="onCheck(0)"
        >拒绝</van-button
      >
      <van-button
        v-if="type != 'check'"
        class="withdraw"
        size="small"
        :disabled="data.ConfirmResult != 1 || loading"
        @click="onWithDraw"
        >撤回</van-button
      >
      <van-button
        v-if="type != 'check'"
        class="cancel"
        type="danger"
        size="small"
        :disabled="data.ConfirmResult != 1 || loading"
        @click="onCancel"
        >取消</van-button
      >
      <van-button
        v-if="type != 'check'"
        class="edit"
        plain
        size="small"
        type="info"
        :disabled="loading"
        @click="onSubmit"
        >修改</van-button
      >
    </div>
    <van-overlay :show="viewImgShow">
      <div class="wrapper" @click.stop @click="viewImgShow = false">
        <img :src="viewImgShowUrl" alt="" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Dialog, Toast, Badge } from "vant";
import moment from "moment";
import dataForm from "@/components/base/form/dataForm";
import buildingManagementApi from "@/api/buildingManagement.js";
import authApi from "@/api/auth";
import { mapState } from "vuex";
export default {
  components: {
    dataForm,
    [Badge.name]: Badge,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  data() {
    return {
      applyId: "",
      viewImgShowUrl: "",
      viewImgShow: false,
      data: {},
      showBeginTimePicker: false,
      showEndTimePicker: false,
      showMeetingDatePicker: false,
      MeetingDate: "",
      items: [],
      type: "", //check:仅审批 edit:可审批、修改、撤回、取消
      params: {},
      loading: false,
    };
  },
  created() {
    if (
      !this.userInfo.Permissions.includes(
        "MainMenu./预订场地./预订场地/申请审批"
      )
    ) {
      this.$router.replace({ path: "/noPermissions" });
    }
    this.type = this.$route.query.type;
    this.applyId = this.$route.query.applyId;
    this.items = [
      {
        title: "审批结果",
        field: "ConfirmResultText",
        itemRender: {
          name:
            this.type == "check" || this.data.AbleToConfirm
              ? "a-hidden"
              : "a-input",
          props: {
            titleWidth: "100px",
            readonly: true,
          },
        },
      },
      {
        title: "开始使用时间",
        field: "BeginTime",
        itemRender: {
          name: "a-date-picker",
          props: {
            titleWidth: "100px",
            type: "time",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "结束使用时间",
        field: "EndTime",
        itemRender: {
          name: "a-date-picker",
          props: {
            titleWidth: "100px",
            type: "time",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "日期",
        field: "MeetingDate",
        itemRender: {
          name: "a-date-picker",
          props: {
            titleWidth: "100px",
            type: "date",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "占用类型",
        field: "OccupyType",
        itemRender: {
          name: "a-select",
          props: {
            api: authApi.QueryEnumDef,
            param: { Types: "MeetingRoomOccupyTypes" },
            dataField: "Data.MeetingRoomOccupyTypes",
            valueField: "Value",
            labelField: "Text",
            titleWidth: "100px",
            disabled: this.type == "check",
          },
          on: {
            change() {},
          },
        },
      },
      {
        title: "联系人",
        field: "Contact",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "手机",
        field: "Phone",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "人数",
        field: "PersonNum",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "会议主题",
        field: "MeetingTopic",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "是否需要讲解员",
        field: "NeedGuide",
        itemRender: {
          name: "a-select",
          disabled: this.type == "check",

          props: {
            valueField: "Value",
            labelField: "Text",
            titleWidth: "100px",
            options: [
              {
                Value: 0,
                Text: "否",
              },
              {
                Value: 1,
                Text: "是",
              },
            ],
          },
        },
      },
      {
        title: "讲解员姓名",
        field: "GuideName",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
          },
        },
      },
      {
        title: "审批人",
        field: "ConfirmDingTalkUserName",
        itemRender: {
          name:
            this.type == "check" || this.data.AbleToConfirm
              ? "a-hidden"
              : "a-input",
          props: {
            titleWidth: "100px",
            disabled: true,
            disabled: this.type == "check",
          },
        },
      },
      {
        field: "ConfirmDingTalkUserId",
        itemRender: {
          name: "a-hidden",
        },
      },

      {
        title: "审批时间",
        field: "ConfirmTime",
        itemRender: {
          name:
            this.type == "check" || this.data.AbleToConfirm
              ? "a-hidden"
              : "a-input",
          props: {
            titleWidth: "100px",
            disabled: true,
          },
        },
      },
      {
        title: "备注",
        field: "Remark",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            disabled: this.type == "check",
            type: "textarea",
          },
        },
      },
      {
        title: "审批备注",
        field: "ConfirmRemark",
        itemRender: {
          name: "a-input",
          props: {
            titleWidth: "100px",
            type: "textarea",
          },
        },
      },
    ];
    this.getDetail();
  },
  methods: {
    getDetail() {
      buildingManagementApi
        .QueryMeetingRoomApply({ applyId: this.applyId })
        .then((res) => {
          this.data = res.Data[0];
          this.data.MeetingDate = moment(this.data.MeetingDate).format(
            "YYYY-MM-DD"
          );
          this.data.OccupyType = Number(this.data.OccupyType);
          this.MeetingDate = this.data.MeetingDate;
          this.data.NeedGuide =
            this.data.NeedGuide == null ? 0 : this.data.NeedGuide;

          if (this.data.OrderStatus == "2" && this.data.ConfirmResult != "0") {
            this.data.ConfirmResultText = "已取消";
          } else if (this.data.ConfirmResult == "1") {
            this.data.ConfirmResultText = "同意";
          } else if (this.data.ConfirmResult == "0") {
            this.data.ConfirmResultText = "已取消";
          } else {
            this.data.ConfirmResultText = "未审批";
          }

          this.data.AttachmentFiles = this.data.AttachmentFiles[0];
          this.$refs.dataForm.setData(this.data);
        });
    },
    onSubmit() {
      this.loading = true;
      if (!this.data.OccupyType) {
        Toast("如需占用，占用类型必填！");
        return;
      }
      const json = {
        ApplyId: this.data.ApplyId,
        ApplyType: this.data.ApplyType,
        BeginTime: this.data.BeginTime,
        ConfirmDingTalkUserId: this.data.ConfirmDingTalkUserId,
        ConfirmDingTalkUserName: this.data.ConfirmDingTalkUserName,
        ConfirmRemark: this.data.ConfirmRemark,
        ConfirmResult: this.data.ConfirmResult,
        ConfirmTime: this.data.ConfirmResult,
        Contact: this.data.Contact,
        EndTime: this.data.EndTime,
        GuestId: this.data.GuestId,
        MeetingDate: this.data.MeetingDate,
        MeetingRoomId: this.data.MeetingRoomId,
        MeetingRoomName: this.data.MeetingRoomName,
        NeedGuide: this.data.NeedGuide,
        OccupyType: this.data.OccupyType,
        OrderStatus: this.data.OrderStatus,
        PersonNum: this.data.PersonNum,
        Phone: this.data.Phone,
        Status: this.data.Status,
        TeamName: this.data.TeamName,
      };
      buildingManagementApi.UpdateMeetingRoomApply(json).then((res) => {
        Toast("操作成功");
        setTimeout(() => {
          this.getDetail();
          this.loading = false;
        }, 1000);
      });
    },
    onBeginTimeConfirm(time) {
      this.data.BeginTime = time;
      this.showBeginTimePicker = false;
    },
    onEndTimeConfirm(time) {
      this.data.EndTime = time;
      this.showEndTimePicker = false;
    },
    onMeetingDateConfirm(time) {
      this.data.MeetingDate = moment(time).format("YYYY-MM-DD");
      this.showMeetingDatePicker = false;
    },
    onOptionsLoadAfter(value) {},
    viewImg(url) {
      this.viewImgShowUrl = url;
      this.viewImgShow = true;
    },
    downloadImage(imageUrl) {
      var link = document.createElement("a");
      link.href = imageUrl;
      link.download = "image.jpg";
      link.click();
    },
    onCheck(type) {
      this.loading = true;
      Dialog.confirm({
        title: "提示",
        message: type ? "是否同意审批？" : "是否拒绝审批？",
      })
        .then(() => {
          const dataFormData = this.$refs.dataForm.getData();
          buildingManagementApi
            .ConfirmMeetingRoomApply({
              ApplyId: this.applyId,
              ConfirmRemark: dataFormData.ConfirmRemark
                ? dataFormData.ConfirmRemark
                : "",
              ConfirmResult: type,
            })
            .then((res) => {
              Toast("操作成功");
              setTimeout(() => {
                this.loading = false;
                this.getDetail();
              }, 1000);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    onWithDraw() {
      this.loading = true;
      Dialog.confirm({
        title: "提示",
        message: "是否撤回？",
      })
        .then(() => {
          buildingManagementApi
            .CancelConfirmMeetingRoomApply({
              ApplyId: this.applyId,
            })
            .then((res) => {
              Toast("操作成功");
              this.loading = false;
              this.getDetail();
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    onCancel() {
      this.loading = true;
      Dialog.confirm({
        title: "提示",
        message: "是否取消？",
      })
        .then(() => {
          buildingManagementApi
            .CancelConfirmAndRefuseMeetingRoomApply({
              ApplyId: this.applyId,
            })
            .then((res) => {
              Toast("操作成功");
              setTimeout(() => {
                this.loading = false;
                this.getDetail();
              }, 1000);
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="less" scoped>
.page-wraper {
  padding-bottom: 50px;
}
.img-box {
  width: 100%;
  // display: flex;

  .attachmentFiles,
  .introductionImageUrls {
    width: 50%;
    text-align: center;
    img {
      width: 80%;
      margin-bottom: 5px;
    }
    p {
      font-size: 14px;
      margin-bottom: 5px;
      color: #888;
      padding: 8px 0;
    }
  }
  .introductionImageUrls {
    width: 100%;
    p {
      text-align: left;
      padding-left: 20%;
    }
  }
  .introductionImageUrls:after {
    content: "";
    display: block;
    clear: both;
  }
  .attachmentFiles {
    // margin: 0 auto;
  }
}
/deep/.van-field__label {
  color: #888;
  font-size: 14px;
  font-weight: 400;
  text-align: right;
}
/deep/.van-field__value {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.footer-button {
  padding: 6px 0;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgb(249, 249, 249);
  display: flex;
  justify-content: space-around;
  button {
    border-radius: 8px;
  }
  // height: 50px;
  // background-color: aqua;
}

.check,
.withdraw,
.cancel,
.edit {
  width: 18%;
}
/deep/.form-item-wraper {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding: 0 !important;
  .van-cell {
    background-color: #fff;
  }
  .van-field__control {
    text-align: left;
  }
  .van-icon {
    font-size: 16px;
    color: #969799;
  }
}
.wrapper {
  position: relative;
  height: 100%;
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
